import { createElement } from 'react';
import { bool, string, object, oneOfType, func, shape } from 'prop-types';
import { b as _objectWithoutPropertiesLoose, c as _extends, a as _objectSpread } from '../chunk-ad6ad343.js';
import _omit from 'lodash/omit';
import Text from '../Text/index.js';
import { formikField, reduxFormField } from '../adaptors/fields.js';
import _Checkbox, { HiddenCheckbox, CheckboxIcon } from './styled.js';
import { a as FieldWrapper, b as fieldWrapperPropTypes, c as fieldWrapperDefaultProps } from '../chunk-1195bf9a.js';

var Checkbox = function Checkbox(_ref) {
  var autoFocus = _ref.autoFocus,
      checked = _ref.checked,
      checkboxRef = _ref.checkboxRef,
      className = _ref.className,
      defaultChecked = _ref.defaultChecked,
      disabled = _ref.disabled,
      id = _ref.id,
      indeterminate = _ref.indeterminate,
      isRequired = _ref.isRequired,
      label = _ref.label,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      name = _ref.name,
      state = _ref.state,
      value = _ref.value,
      props = _objectWithoutPropertiesLoose(_ref, ["autoFocus", "checked", "checkboxRef", "className", "defaultChecked", "disabled", "id", "indeterminate", "isRequired", "label", "onBlur", "onChange", "onFocus", "name", "state", "value"]);

  return createElement(_Checkbox, _extends({
    "aria-invalid": state === 'danger',
    "aria-required": isRequired
  }, props), createElement(HiddenCheckbox, {
    autoFocus: autoFocus,
    checked: checked,
    defaultChecked: defaultChecked,
    disabled: disabled,
    elementRef: checkboxRef,
    id: id,
    indeterminate: indeterminate,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    name: name,
    state: state,
    type: "checkbox" // @ts-ignore
    ,
    value: value
  }), createElement(CheckboxIcon, {
    state: state
  }), label && createElement(Text, {
    marginLeft: "minor-2"
  }, label));
};

Checkbox.Formik = formikField(Checkbox, {
  isCheckbox: true
});
Checkbox.ReduxForm = reduxFormField(Checkbox, {
  isCheckbox: true
});
var checkboxPropTypes = {
  autoFocus: bool,
  checked: bool,
  className: string,
  checkboxRef: object,
  defaultChecked: bool,
  disabled: bool,
  id: string,
  indeterminate: bool,
  isRequired: bool,
  label: string,
  name: string,
  state: string,
  value: oneOfType([bool, string]),
  onBlur: func,
  onChange: func,
  onFocus: func
};
Checkbox.propTypes = checkboxPropTypes;
var checkboxDefaultProps = {
  autoFocus: false,
  checked: undefined,
  className: undefined,
  checkboxRef: undefined,
  defaultChecked: undefined,
  disabled: false,
  id: undefined,
  indeterminate: false,
  isRequired: false,
  label: undefined,
  onBlur: undefined,
  onChange: undefined,
  onFocus: undefined,
  name: undefined,
  state: undefined,
  value: undefined
};
Checkbox.defaultProps = checkboxDefaultProps; // @ts-ignore

var C = Checkbox;

var CheckboxField = function CheckboxField(_ref) {
  var a11yId = _ref.a11yId,
      autoFocus = _ref.autoFocus,
      checkboxLabel = _ref.checkboxLabel,
      checkboxProps = _ref.checkboxProps,
      checkboxRef = _ref.checkboxRef,
      checked = _ref.checked,
      className = _ref.className,
      defaultChecked = _ref.defaultChecked,
      description = _ref.description,
      disabled = _ref.disabled,
      hint = _ref.hint,
      label = _ref.label,
      indeterminate = _ref.indeterminate,
      id = _ref.id,
      isOptional = _ref.isOptional,
      isRequired = _ref.isRequired,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      name = _ref.name,
      state = _ref.state,
      validationText = _ref.validationText,
      value = _ref.value,
      props = _objectWithoutPropertiesLoose(_ref, ["a11yId", "autoFocus", "checkboxLabel", "checkboxProps", "checkboxRef", "checked", "className", "defaultChecked", "description", "disabled", "hint", "label", "indeterminate", "id", "isOptional", "isRequired", "onBlur", "onChange", "onFocus", "name", "state", "validationText", "value"]);

  return createElement(FieldWrapper, _extends({
    a11yId: a11yId,
    description: description,
    hint: hint,
    isOptional: isOptional,
    isRequired: isRequired,
    label: label,
    state: state,
    validationText: validationText
  }, props), function (_ref2) {
    var elementProps = _ref2.elementProps;
    return createElement(C, _extends({
      autoFocus: autoFocus,
      checked: checked,
      checkboxRef: checkboxRef,
      className: className,
      defaultChecked: defaultChecked,
      disabled: disabled,
      id: id,
      indeterminate: indeterminate,
      isRequired: isRequired,
      label: checkboxLabel,
      name: name,
      state: state // @ts-ignore
      ,
      value: value,
      onBlur: onBlur,
      onChange: onChange,
      onFocus: onFocus
    }, elementProps, checkboxProps));
  });
};

CheckboxField.Formik = formikField(CheckboxField, {
  hasFieldWrapper: true,
  isCheckbox: true
});
CheckboxField.ReduxForm = reduxFormField(CheckboxField, {
  hasFieldWrapper: true,
  isCheckbox: true
});
CheckboxField.propTypes = _objectSpread({
  checkboxLabel: string,
  checkboxProps: shape(checkboxPropTypes)
}, checkboxPropTypes, _omit(fieldWrapperPropTypes, 'children'));
CheckboxField.defaultProps = _objectSpread({
  checkboxProps: {}
}, checkboxDefaultProps, fieldWrapperDefaultProps); // @ts-ignore

var C$1 = CheckboxField;
export { C as a, CheckboxField as b, C$1 as c, checkboxPropTypes as d, checkboxDefaultProps as e };